import Scoreboard from "../components/Scoreboard";
import {Box} from "@mui/material";

const ScoreboardPage = () => {
    return (
        <Box margin={2} height="100%">
            <Scoreboard/>
        </Box>
    );
};

export default ScoreboardPage;